import $http from './http'
import config from './config'

export default {
    name: 'message',
    getUrl(url) {
        return config.getUrl(this.name, url);
    }
}



// WEBPACK FOOTER //
// ./src/apis/messageApi.js